// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"47":"754ef700","168":"79d47721","396":"e0240847","514":"98dc07f7","655":"493e975e","990":"2efee289"}[chunkId] + ".chunk.css";
};